import { render } from "./AcercadeView.vue?vue&type=template&id=f10075fc&scoped=true"
import script from "./AcercadeView.vue?vue&type=script&lang=js"
export * from "./AcercadeView.vue?vue&type=script&lang=js"

import "./AcercadeView.vue?vue&type=style&index=0&id=f10075fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10075fc"]])

export default __exports__